<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/liveshopping.mp4"></video>
      <p class="description pd-top-40">
        Live Shopping Parade adalah rangkaian acara live persembahan eMShop, The F Thing, AladinMall bersama Aladin Travel berdurasi 1 jam yang akan dilaksanakan pada tanggal 1-4 November 2021 setiap pukul 14.00 WIB. Ayo ikutan dan temukan kejutan belanja setiap harinya. 
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Parade',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/parade-live')
    }
  }
}
</script>
